<template>
  <div>
    <div class="info">
      <div class="company-name">AC Orange Co., Ltd.</div>
      <div class="business">
        <div class="business-item">
          <div class="business-products">Produce &amp;&nbsp;Present</div>
        </div>
        <div class="business-item">
          <div class="business-content">
            Content investment and Incubators
          </div>
        </div>
        <div class="business-item">
          <div class="business-tour">Performances Tour</div>
        </div>
        <div class="business-item">
          <div class="business-theatre">Theatre operation</div>
        </div>
        <div class="business-item">
          <div class="business-ticket" style="height:30px;">Ticketing</div>
        </div>
      </div>
      <div class="intro">
        <div class="intro__item">
          <span class="intro__item__dot"></span
          ><span class="intro__item__text"
            >ACOrange is the largest private performance enterprise in
            China.</span
          >
        </div>
        <div class="intro__item">
          <span class="intro__item__dot"></span
          ><span class="intro__item__text"
            >We apply strategic planning to cover all segments of perfomance
            industry.</span
          >
        </div>
        <div class="intro__item">
          <span class="intro__item__dot"></span
          ><span class="intro__item__text"
            >Our content covers of all performance genres.</span
          >
        </div>
        <div class="intro__item">
          <span class="intro__item__dot"></span
          ><span class="intro__item__text"
            >We are the first Chinese Corporation investing in Broadway
            musicals.</span
          >
        </div>
        <div class="intro__item">
          <span class="intro__item__dot"></span
          ><span class="intro__item__text"
            >Orange Theaters，the largest theatre management group in China.</span
          >
        </div>
      </div>
      <div class="bubble">
        <LayoutBubble style="transform:scale(1.321)"></LayoutBubble>
      </div>
    </div>
    <Achievement></Achievement>
  </div>
</template>
<script>
import LayoutBubble from "../LayoutBubble";
import Achievement from "../Achievement";
export default {
  components: {
    LayoutBubble,
    Achievement
  }
};
</script>
<style lang="scss" scoped>
.info {
  width: 1200px;
  margin: 0 auto;
}
.company-name {
  height: 33px;
  line-height: 33px;
  font-size: 30px;
  font-weight: 400;
  color: rgba(46, 41, 37, 1);
  margin-top: 70px;
}
.business {
  margin-top: 52px;
  color: #ec6900;
  font-size: 20px;
  &-item {
    height: 80px;
    line-height: 80px;
    display: inline-block;
    padding: 0 20px;
    border: 1px solid rgba(236, 105, 0, 1);
    .business-products {
      width: 96px;
      display: inline-block;
      line-height: 30px;
      height: 60px;
      vertical-align: middle;
    }

    .business-content {
      display: inline-block;
      width: 192px;
      line-height: 30px;
      height: 60px;
      vertical-align: middle;
    }
    .business-tour {
      display: inline-block;
      width: 130px;
      line-height: 30px;
      height: 60px;
      vertical-align: middle;
    }
    .business-theatre {
      display: inline-block;
      width: 92px;
      line-height: 30px;
      height: 60px;
      vertical-align: middle;
    }
    .business-ticket {
      display: inline-block;
      width: 85px;
      line-height: 30px;
      height: 60px;
      vertical-align: middle;
    }
  }
}
.intro {
  font-size: 22px;
  color: #5b5755;
  margin-top: 27px;
  &__item {
    height: 40px;
    line-height: 40px;
    &__dot {
      width: 8px;
      height: 8px;
      background: rgba(218, 218, 218, 1);
      border-radius: 50%;
      display: inline-block;
      vertical-align: middle;
    }
    &__text {
      margin-left: 26px;
      vertical-align: middle;
    }
  }
}
.bubble {
  text-align: center;
  margin-top: 71px;
  margin-bottom: 90px;
}
.business-item:not(:first-child) {
  margin-left: 22px;
}
</style>